import React, { memo } from 'react';
import { FileTextIcon, ClockIcon, BarChartIcon, ShoppingCartIcon, ShieldCheckIcon, MailIcon } from 'lucide-react';
import { trackPurchaseClick } from '../utils/MetaPixel';
export const Features = () => {
  return <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-169">
      <div className="max-w-7xl mx-auto" data-id="element-170">
        <div className="text-center mb-10" data-id="element-171">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-172">
            ¿Qué incluye el Recetario Fit?
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-173">
            Todo lo que necesitas para transformar tu cocina y tu alimentación
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-174">
          <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-175">
            <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-176">
              <FileTextIcon className="h-6 w-6 text-teal-600" data-id="element-177" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-178">
              +60 recetas
            </h3>
            <p className="text-gray-700 text-center" data-id="element-179">
              Desayunos, almuerzos, cenas y snacks. Todas probadas y aprobadas.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-180">
            <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-181">
              <ClockIcon className="h-6 w-6 text-teal-600" data-id="element-182" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-183">
              Plan de 4 semanas
            </h3>
            <p className="text-gray-700 text-center" data-id="element-184">
              Organización semanal para que nunca más te preguntes "¿qué
              comemos?"
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-185">
            <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-186">
              <BarChartIcon className="h-6 w-6 text-teal-600" data-id="element-187" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-188">
              Macros por porción
            </h3>
            <p className="text-gray-700 text-center" data-id="element-189">
              Control total de calorías, proteínas, grasas y carbohidratos.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-190">
            <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-191">
              <ShoppingCartIcon className="h-6 w-6 text-teal-600" data-id="element-192" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-193">
              Listas imprimibles
            </h3>
            <p className="text-gray-700 text-center" data-id="element-194">
              Listas de compras organizadas para ahorrar tiempo y dinero.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-195">
            <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-196">
              <ShieldCheckIcon className="h-6 w-6 text-teal-600" data-id="element-197" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-198">
              Garantía 7 días
            </h3>
            <p className="text-gray-700 text-center" data-id="element-199">
              Devolución 100% garantizada. Si no te sirve, te devolvemos tu
              dinero sin preguntas.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-200">
            <div className="bg-teal-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-201">
              <MailIcon className="h-6 w-6 text-teal-600" data-id="element-202" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-203">
              Entrega inmediata
            </h3>
            <p className="text-gray-700 text-center" data-id="element-204">
              Recibe todo por email apenas completas tu compra.
            </p>
          </div>
        </div>
        <div className="mt-10 text-center" data-id="element-205">
          <a href="https://organicecomm.com/cart/51818275930293:1" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 text-xl w-full sm:w-auto" onClick={trackPurchaseClick} data-id="element-206">
            Quiero mi recetario por $17 USD
          </a>
          <p className="mt-4 text-sm text-gray-600" data-id="element-207">
            Pruébalo 7 días. Si no te sirve, devolución 100%.
          </p>
        </div>
      </div>
    </section>;
};